import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'logo-footer-modulo',
  templateUrl: './logo-footer-modulo.component.html',
  styleUrls: ['./logo-footer-modulo.component.scss']
})
export class LogoFooterModuloComponent implements OnInit {

  @Input("data") data = null;

  constructor() { }

  /**
   * 
   * Init
   * 
   */
  ngOnInit():void{}

}
